import { createGridLayout, createGridItem } from "../../../../store/global/gridlayout";
import { getIntegerRange } from "../../../../utility";

export const contactGridItemRouteMap = {
  'overview': getIntegerRange(0, 4),
  'additional_info':getIntegerRange(5, 8),
  'accounting_info':getIntegerRange(9, 16),
}

export const contactDetailsGrid = createGridLayout({
  layout: [
    createGridItem({    //0
      x: 0,
      y: 0,
      w: 25,
      h: 23.5,
      i: 'contact',
    }),
    createGridItem({    //1
      x: 25,
      y: 0,
      w: 35,
      h: 14,
      i: 'related_contacts',
    }),
    createGridItem({    //2
      x: 0,
      y: 23.5,
      w: 20,
      h: 16,
      i: 'communication_info',
    }),
    createGridItem({    //4
      x: 20,
      y: 23.5,
      w: 20,
      h: 16,
      i: 'submenu_GROUPS',
    }),
    createGridItem({    //3
      x: 40,
      y: 23.5,
      w: 20,
      h: 16,
      i: 'notes',
    }),
    createGridItem({    //5
      x: 0,
      y: 39.5,
      w: 60,
      h: 5,
      i: 'additional_infos',
    }),
    createGridItem({    //6
      x: 0,
      y: 44.5,
      w: 20,
      h: 20,
      i: 'related_documents',
    }),
    createGridItem({    //7
      x: 20,
      y: 44.5,
      w: 40,
      h: 20,
      i: 'tab_title_custom_fields',
    }),
    // createGridItem({    //8
    //   x: 30,
    //   y: 51.7,
    //   w: 30,
    //   h: 15,
    //   i: 'contact_buttons',
    // }),
    createGridItem({    //9
      x: 0,
      y: 64.5,
      w: 60,
      h: 5,
      i: 'tab_title_accounting_info',
    }),
    createGridItem({    //10
      x: 0,
      y: 69.5,
      w: 20,
      h: 18.2,
      i: 'accounting_details',
    }),
    createGridItem({    //15
      x: 20,
      y: 69.5,
      w: 20,
      h: 12.2,
      i: 'outgoing_invoices_txt',
    }),
    createGridItem({    //16
      x: 40,
      y: 69.5,
      w: 20,
      h: 12.2,
      i: 'incoming_invoices_txt',
    }),
    createGridItem({    //17
      x: 0,
      y: 87.7,
      w: 30,
      h: 5,
      i: 'bank_details',
    }),
    createGridItem({    //11
      x: 20,
      y: 92.7,
      w: 60,
      h: 5,
      i: 'tab_title_invoices',
    }),
    createGridItem({    //11
      x: 20,
      y: 97.7,
      w: 60,
      h: 15,
      i: 'invoice',
    }),
    createGridItem({    //14
      x: 20,
      y: 112.7,
      w: 60,
      h: 15,
      i: 'tab_title_costs',
    }),
  ]
});